import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ClientLibraryNavService {
  private readonly backToPatientSubject = new Subject<void>();
  readonly backToPatient$: Observable<void> = this.backToPatientSubject.asObservable();

  requestBackToPatient(): void {
    this.backToPatientSubject.next();
  }
}
